import {
  createStart,
  createMiddleware,
} from "@tanstack/react-start";
import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware,
} from "@sentry/tanstackstart-react";
import * as Sentry from "@sentry/tanstackstart-react";

import { renderErrorPage } from "./lib/error-page";

/**
 * App-level HTML fallback for catastrophic SSR failures.
 * Sentry global middlewares must stay FIRST so they still see the error.
 */
const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    Sentry.captureException(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  // Sentry docs: global middlewares MUST be the first entries.
  requestMiddleware: [sentryGlobalRequestMiddleware, errorMiddleware],
  functionMiddleware: [sentryGlobalFunctionMiddleware],
}));
